module.exports = __webpack_public_path__ + "static/media/Kirk_Larsen_2026_PDF.9d70290b.pdf";